/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import { debounce } from 'lodash';
import React, { useEffect, useState } from 'react';
import breakpoints from '../../../config/breakpoints';
import mediaURL from '../../../util/mediaURL';
import Dropdown from '../Atoms/Dropdown';
import DropdownMultiple from '../Atoms/DropdownMultiple';
import Icon from '../Atoms/Icon';
import { inspireMeDropdownValue } from './constants';
import ImageDropdown from './modules/ImageDropdown';
import PackageFilterContainer from './modules/PackageFilterContainer';
import TourTypeSubFilterSlider from './modules/TourTypeSubFilterSlider';

const PackageFilter = ({
  allOptionText,
  packages,
  labels,
  inspireMe,
  packageTypeSubFilterAllOptionText,
  packageTypes,
  tourTypeSubFilters,
  handlePackageValueChange,
  handleValueChange,
  destinations,
  partySizes,
  holidayTypes,
  attractions,
  tournamentDestinationOptions,
}) => {
  const inspireMeSelected = packageTypes === inspireMeDropdownValue;

  const [showPartialAnimation, setShowPartialAnimation] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  if (!packages || packages.length === 0) return null;

  const checkIfMobile = () => {
    if (window.innerWidth < breakpoints.tablet) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    const handleWindowResize = debounce(checkIfMobile, 200);
    window.addEventListener('resize', handleWindowResize, { passive: true });
    checkIfMobile();
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [checkIfMobile]);

  const selectedPackageItem = packageTypes
    ? packages.find((x) => x.id.toString() === packageTypes.toString())
    : { title: allOptionText ?? 'All' };

  const togglePackage = (id) => {
    handlePackageValueChange(packageTypes === id ? '' : id, []);
  };

  const handleMultipleSelectChange = (fieldName, values) => {
    const payload = { [fieldName]: values };
    handleValueChange(payload);
  };

  const togglePackageOption = (id) => {
    if (tourTypeSubFilters?.includes(id)) {
      handlePackageValueChange(
        packageTypes,
        tourTypeSubFilters.filter((x) => x !== id)
      );
    } else {
      handlePackageValueChange(packageTypes, [...tourTypeSubFilters, id]);
    }
  };

  const selectedPackageItemPages = Math.ceil(
    (selectedPackageItem?.tourTypeSubFilter?.length || []) / 4
  );

  const destinationOptions = tournamentDestinationOptions
    ? inspireMe?.destinations?.items.filter((item) =>
        tournamentDestinationOptions.find((dest) => dest.id === item.id)
      )
    : inspireMe?.destinations?.items;

  return (
    <>
      <PackageFilterContainer>
        <form className="PackageFilter PackageFilter_packageOptionsContainer">
          <div className="PackageFilter_fieldset PackageFilter_packageOptions">
            <div className="PackageFilter_packageOptionsTitle">
              {labels.tourTypeFilterLabelText}:
            </div>
            <div className="PackageFilter_packageOptionsButtons">
              {packages.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`Button ${
                    packageTypes?.toString() === item.id?.toString()
                      ? 'Button-fill selected'
                      : 'Button-alt'
                  }`}
                  onClick={() => togglePackage(item.id)}
                >
                  {item.title}
                </button>
              ))}
            </div>
            <div className="PackageFilter_flexFill" />
            {inspireMe && (
              <button
                type="button"
                className={`Button ${
                  inspireMeSelected ? 'Button-fill selected' : 'Button-outline'
                }`}
                onClick={() => togglePackage(inspireMeDropdownValue)}
              >
                {labels.inspireMeFilterText}
              </button>
            )}
          </div>
          <div className="PackageFilter_packageOptionsMobile">
            <div className="PackageFilter_fieldset">
              <div className="PackageFilter_field PackageFilter_packageSelect">
                <Dropdown
                  blockName="PackageFilter_input"
                  fieldName="party"
                  modifier="filter"
                  handleChange={(e) => togglePackage(e.target.value)}
                  options={[
                    { value: '', text: allOptionText ?? 'All' },
                    ...packages.map((item) => ({ text: item.title, value: item.id })),
                    { value: inspireMeDropdownValue, text: labels.inspireMeFilterText },
                  ]}
                  fieldValue={inspireMeSelected ? inspireMeDropdownValue : packageTypes}
                  overlay={
                    <>
                      {labels.tourTypeFilterLabelText}:{' '}
                      <span>
                        {inspireMeSelected
                          ? labels.inspireMeFilterText
                          : selectedPackageItem?.title}
                      </span>
                    </>
                  }
                />
              </div>
            </div>
          </div>
        </form>
        {inspireMeSelected && (
          <form className="PackageFilter">
            <div className="PackageFilter_fieldset">
              {inspireMe?.partySizes && (
                <div className="PackageFilter_field">
                  <DropdownMultiple
                    blockName="PackageFilter_input"
                    fieldName="partySizes"
                    handleChange={handleMultipleSelectChange}
                    labelText={labels.partySizeFilterText}
                    showIcon={!inspireMe.partySizes.items.find((x) => !x.icon)}
                    options={inspireMe.partySizes.items.map((x) => ({
                      value: x.id,
                      text: x.title,
                      category: x.category,
                      image: x.image,
                      icon: x.icon,
                    }))}
                    selectedValues={partySizes}
                    fullScreenMobile
                  />
                </div>
              )}
              {inspireMe?.holidayTypes && (
                <div className="PackageFilter_field">
                  <DropdownMultiple
                    blockName="PackageFilter_input"
                    fieldName="holidayTypes"
                    handleChange={handleMultipleSelectChange}
                    labelText={labels.holidayTypeFilterText}
                    showIcon={!inspireMe.holidayTypes.items.find((x) => !x.icon)}
                    options={inspireMe.holidayTypes.items.map((x) => ({
                      value: x.id,
                      text: x.title,
                      category: x.category,
                      image: x.image,
                      icon: x.icon,
                    }))}
                    selectedValues={holidayTypes}
                    fullScreenMobile
                  />
                </div>
              )}
              {inspireMe?.destinations && (
                <div className="PackageFilter_field">
                  {(!inspireMe.destinations.displayAsGrid || isMobile) && (
                    <DropdownMultiple
                      blockName="PackageFilter_input"
                      fieldName="destinations"
                      handleChange={handleMultipleSelectChange}
                      labelText={labels.destinationFilterText}
                      showIcon={!destinationOptions.find((x) => !x.icon)}
                      options={destinationOptions.map((x) => ({
                        value: x.id,
                        text: x.title,
                        category: x.category,
                        image: x.image,
                        icon: x.icon,
                      }))}
                      selectedValues={destinations}
                      fullScreenMobile
                    />
                  )}
                  {inspireMe.destinations.displayAsGrid && !isMobile && (
                    <ImageDropdown
                      data={inspireMe.destinations.items}
                      selectedIds={destinations}
                      blockName="PackageFilter_input"
                      fieldName="destinations"
                      labelText={labels.destinationFilterText}
                      onChange={handleMultipleSelectChange}
                    />
                  )}
                </div>
              )}
              {inspireMe?.attractions && (
                <div className="PackageFilter_field">
                  {(!inspireMe.attractions.displayAsGrid || isMobile) && (
                    <DropdownMultiple
                      blockName="PackageFilter_input"
                      fieldName="attractions"
                      handleChange={handleMultipleSelectChange}
                      labelText={labels.attractionFilterText}
                      showIcon={!inspireMe.attractions.items.find((x) => !x.icon)}
                      options={inspireMe.attractions.items.map((x) => ({
                        value: x.id,
                        text: x.title,
                        category: x.category,
                        image: x.image,
                        icon: x.icon,
                      }))}
                      selectedValues={attractions}
                      fullScreenMobile
                    />
                  )}
                  {inspireMe.attractions.displayAsGrid && !isMobile && (
                    <ImageDropdown
                      data={inspireMe.attractions.items}
                      selectedIds={attractions}
                      blockName="PackageFilter_input"
                      fieldName="attractions"
                      labelText={labels.attractionFilterText}
                      onChange={handleMultipleSelectChange}
                    />
                  )}
                </div>
              )}
            </div>
          </form>
        )}
      </PackageFilterContainer>
      <div className="PackageSearch_filter">
        <div className="PackageSearch_filterContainer PackageSearch_packageSubOptionsSlider">
          {selectedPackageItemPages > 0 && selectedPackageItem && (
            <form className="PackageFilter PackageFilter_packageSubOptionsContainer">
              <div
                className={`PackageFilter_fieldset PackageFilter_packageSubOptions ${
                  showPartialAnimation ? 'partial' : ''
                }`}
                onTouchStart={() => (showPartialAnimation ? setShowPartialAnimation(false) : null)}
              >
                <div className="PackageFilter_field">
                  <div className="PackageFilter_input">
                    <button
                      type="button"
                      className={`PackageFilter_button Button ${
                        tourTypeSubFilters?.length === 0 ? 'active' : ''
                      }`}
                      onClick={() => handlePackageValueChange(packageTypes, [])}
                    >
                      <Icon id="ticket" blockName="PackageFilter_icon" />
                      {packageTypeSubFilterAllOptionText}
                    </button>
                  </div>
                </div>
                <TourTypeSubFilterSlider
                  items={selectedPackageItem.tourTypeSubFilter}
                  selectedItems={tourTypeSubFilters}
                  togglePackageOption={togglePackageOption}
                />
                {selectedPackageItem.tourTypeSubFilter &&
                  selectedPackageItem.tourTypeSubFilter.map((item) => (
                    <div
                      className="PackageFilter_field PackageFilter_field-flex PackageFilter_slider-item PackageFilter_slider-itemMobile"
                      key={item.id}
                    >
                      <div className="PackageFilter_input">
                        <button
                          type="button"
                          className={`PackageFilter_button Button ${
                            tourTypeSubFilters.includes(item.id) ? 'active' : ''
                          }`}
                          onClick={() => togglePackageOption(item.id)}
                        >
                          {item.icon && (
                            <img
                              className="PackageFilter_itemIcon"
                              src={mediaURL(item.icon.url)}
                              alt={item.icon.alt}
                            />
                          )}
                          {item.title}
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default PackageFilter;
